import React from "react";
import { Link } from "react-router-dom";
import { InstagramEmbed } from "react-social-media-embed";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import InstagramIcon from "@mui/icons-material/Instagram";
import PhoneIcon from "@mui/icons-material/Phone";
import "../../style/home.css";
import { ReactComponent as Logo } from "../../logo/KGLOGOFINAL-1.svg";

function Home() {
  return (
    <div className='home-page'>
      {/* Hero Section */}
      <div className='home-hero'>
        <div className='hero-overlay'></div>
        <div className='hero-content'>
          <Logo className='hero-logo' />
          <h1 className='hero-title'>
            Welcome to <span className='hero-brand'>KG</span>
          </h1>
          <p className='hero-subtitle'>
            Authentic Japanese Donburi & Culinary Excellence
          </p>
          <p className='hero-description'>
            Experience the rich heritage of traditional Japanese cuisine in the heart of Auckland
          </p>
          <div className='hero-buttons'>
            <Link to='/menu' className='hero-btn hero-btn-primary'>
              <ShoppingCartIcon sx={{ fontSize: 24 }} />
              Order Online
            </Link>
            <Link to='/view-menu' className='hero-btn hero-btn-secondary'>
              <RestaurantMenuIcon sx={{ fontSize: 24 }} />
              View Menu
            </Link>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className='home-features'>
        <h2 className='section-title'>Why Choose KG?</h2>
        <div className='features-grid'>
          <div className='feature-card'>
            <Link to="/about">
            <div className='feature-icon'>
              <LocalDiningIcon sx={{ fontSize: 48 }} />
            </div>
            
            <h3 className='feature-title'>Authentic Recipes</h3>
            <p className='feature-description'>
              Traditional Japanese donburi prepared with genuine techniques and the finest ingredients
            </p>
            </Link>
          </div>

          <div className='feature-card'>
            <Link to='/menu'>
            <div className='feature-icon'>
              <ShoppingCartIcon sx={{ fontSize: 48 }} />
            </div>
            <h3 className='feature-title'>Online Ordering</h3>
            <p className='feature-description'>
              Convenient online ordering with quick pickup - your favorite dishes ready when you are
            </p>
            </Link>
          </div>

          <div className='feature-card'>
            <Link to="/menu">
            <div className='feature-icon'>
              <RestaurantMenuIcon sx={{ fontSize: 48 }} />
            </div>
            <h3 className='feature-title'>Diverse Menu</h3>
            <p className='feature-description'>
              From classic donburi to innovative creations - explore our extensive menu offerings
            </p>
            </Link>
          </div>
        </div>
      </div>

      {/* Instagram Section */}
      <div className='home-instagram'>
        <h2 className='section-title'>Follow Our Journey</h2>
        <p className='section-subtitle'>
          Stay updated with our latest dishes and special offerings
        </p>
        <div className='instagram-embed-container'>
          <InstagramEmbed
            url='https://www.instagram.com/p/Cvj5gzeSWDL/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA=='
            width={328}
          />
        </div>
        <a
          href='https://www.instagram.com/kg_jp_restaurant/'
          target='_blank'
          rel='noopener noreferrer'
          className='instagram-link'
        >
          <InstagramIcon sx={{ fontSize: 24 }} />
          @kg_jp_restaurant
        </a>
      </div>

      {/* CTA Section */}
      <div className='home-cta'>
        <div className='cta-content'>
          <h2 className='cta-title'>Ready to Order?</h2>
          <p className='cta-subtitle'>
            Experience authentic Japanese cuisine today
          </p>
          <div className='cta-buttons'>
            <Link to='/menu' className='cta-btn cta-btn-primary'>
              <ShoppingCartIcon sx={{ fontSize: 20 }} />
              Start Your Order
            </Link>
            <a href='tel:6493078080' className='cta-btn cta-btn-secondary'>
              <PhoneIcon sx={{ fontSize: 20 }} />
              Call Us: 09 307 8080
            </a>
          </div>
        </div>
      </div>

      {/* Location Info */}
      <div className='home-location'>
        <div className='location-content'>
          <h3 className='location-title'>Visit Us</h3>
          <p className='location-address'>
            📍 211 Parnell Road, Parnell, Auckland 1052
          </p>
          <p className='location-hours'>
            🕐 Monday - Saturday: 11:45 AM - 3:00 PM then 5:00pm to 8:30pm 
            <br></br>
            <b>(Except Friday)</b>
          </p>
          <p className="location-hours">
            🕐 Friday : 11:45 AM - 3:00 PM then 5:00pm to 12:00 AM (Midnight)
          </p>
          <p className="location-hours">
            🕐 Sunday : <b>CLOSED</b>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
